import(/* webpackMode: "eager" */ "/app/src/app/providers.tsx");
import(/* webpackMode: "eager" */ "/app/src/styles/globals.scss")